import React, { useEffect, useState } from 'react'
import KonfhubContainer from '../../../revampComponents/Atom/Container'
import { categoryEntity, handleError, mapEntities, TOGGLEMODE } from '../TaskManagement/TaskManagementConstant'
import { getCategoryEntity } from '../../../revampCRUD/categoryEntity.curd'
import { getEventEntity } from '../../../revampCRUD/EventEntity.curd'
import { CHAR_LIMITS, entityModule } from '../../EventInfo/config/constants'
import RichTextEditor from '../../../revampComponents/RichTextEditor'
import UploadFiles from '../TaskManagement/UploadFiles'
import TwoLabelSwitch from '../../../revampComponents/Atom/TwoLabelSwitch'
import TagsComponent from '../../../revampComponents/Atom/Tags/TagsComponent'
import Checkbox from '../../../revampComponents/Atom/Input/Checkbox'
import FormButtons from '../../../revampComponents/Molecule/Buttons/FormButtons'
import { scrollToError } from '../../../Utils/helpers'
import LoadingSpinner from '../../../revampComponents/Atom/Loading'
import { useHistory, useParams } from "react-router-dom"
import DropdownWithIcon from '../TaskManagement/DropdownWithIcon'
import { DeleteModal } from '../../../revampComponents/Atom/Modals'
import { dashboardColors, theme } from '../../../themes/Theme'
import { uploadFile } from '../../../revampCRUD/uploads.crud'
import { ErrMessages, SUCCESS_MESSAGES } from '../../EventInfo/config/error-constants'
import customToast from '../../../components/common/basic/Toast'
import { JS_TYPES } from '../../../reusable/common'
import { ASSET_TYPE_MAPPING, ASSET_TYPE_REVERSE_MAPPING } from './AssetLibraryConstant'


const AddNEditAsset = ({
    formik = {},
    isEdit = false,
    assetTypes = {},
    eventInfo = {},
    loading = false,
    isExhibitorToggle = true,
    onShareTypeToggle = () => { },
    setIsExhibitorToggle,
    setLoading,
    assetDetails
}) => {
    const history = useHistory()
    const { eventId, exhibitorId } = useParams()
    const [isChecked, setIsChecked] = useState([]);
    const [filterTags, setFilterTags] = useState([])
    const [exhibitorData, setExhibitorData] = useState([])
    const [categoryData, setCategoryData] = useState([])
    const [toggleState, setToggleState] = useState({
        toggleMode: isExhibitorToggle ? TOGGLEMODE?.EXHIBITOR : TOGGLEMODE?.CATEGORY
    })
    const [tagsData, setTagsData] = useState([])
    const [value, setValue] = useState("")
    const [openSelectTicketDropdown, setOpenSelectTicketDropdown] = useState(false)
    const [assetTypeChangeModal, setAssetTypeChangeModal] = useState(false)
    const [pendingAssetType, setPendingAssetType] = useState(null)
    const [exhibitorTags, setExhibitorTags] = useState([])
    const [exhibitorChecked, setExhibitorChecked] = useState([])
    const [categoryTags, setCategoryTags] = useState([])
    const [categoryChecked, setCategoryChecked] = useState([])
    const [fileUploadLoading, setFileUploadLoading] = useState(false)
    const [isInitialized, setIsInitialized] = useState(false);

    const assetTypeOptions = Object.entries(assetTypes)?.map(([key, value]) => ({
        value: value,
        label: value,
    }))

    const openDropDown = () => {
        setOpenSelectTicketDropdown(true)
    }

    const eventEntityFunction = async (id) => {
        try {
            const result = await getEventEntity(id, entityModule?.EXHIBITOR)
            if (result) {
                const allEntities = mapEntities(result?.data?.categorized, result?.data?.uncategorized)
                setExhibitorData(allEntities)
                setFilterTags(toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR ? allEntities : categoryData)
            }
        } catch (err) {
            handleError(err)
        }
    }

    const eventCategoryFunction = async (id) => {
        try {
            const result = await getCategoryEntity(id, categoryEntity?.EXHIBITOR)
            if (result) {
                setCategoryData(result?.data)
                if (toggleState?.toggleMode === TOGGLEMODE?.CATEGORY) {
                    setFilterTags(result?.data)
                }
            }
        } catch (err) {
            handleError(err)
        }
    }

    useEffect(() => {
        if (eventInfo?.event_id) {
            eventEntityFunction(eventInfo?.event_id)
            eventCategoryFunction(eventInfo?.event_id)
        }
    }, [eventInfo?.event_id])

    const updateContent = (content) => {
        formik.setFieldValue('description', content)
    }

    const updateAssigneeToggle = (field, value) => {
        const newToggleState = { ...toggleState, [field]: value };
        setToggleState(newToggleState);

        if (value === TOGGLEMODE.CATEGORY) {
            setExhibitorTags(tagsData);
            setExhibitorChecked(isChecked);

            if (isEdit) {
                // Clear exhibitors, keep _original for delete
                if (formik.values.exhibitors?._original?.length > 0) {
                    formik.setFieldValue('exhibitors', {
                        items: [],
                        _original: []
                    });
                }
            }

            setTagsData(categoryTags);
            setIsChecked(categoryChecked);
            setFilterTags(categoryData);

        } else {
            setCategoryTags(tagsData);
            setCategoryChecked(isChecked);

            if (isEdit) {
                // Reset exhibitors for fresh start
                formik.setFieldValue('exhibitors', {
                    items: [],
                    _original: []
                });

                // Clear categories, keep _original for delete
                if (formik?.values?.categories?._original?.length > 0 ||
                    formik?.values?.category_ids?.length > 0) {
                    formik.setFieldValue('categories.items', []);
                }

                formik.setFieldValue('category_ids', []);
            }

            setTagsData(exhibitorTags);
            setIsChecked(exhibitorChecked);
            setFilterTags(exhibitorData);
        }

        onShareTypeToggle(value === TOGGLEMODE.EXHIBITOR);
    };

    const handleChange = (e) => {
        const searchValue = e?.target?.value?.toLowerCase()
        setValue(e?.target?.value)

        const filteredTags = (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR
            ? exhibitorData
            : categoryData
        ).filter((tag) =>
            (tag?.category_name || tag?.name || tag?.label || tag?.title)?.toLowerCase()?.includes(searchValue)
        )
        setFilterTags(filteredTags)
        setOpenSelectTicketDropdown(true)
    }

    const deleteClickHandler = (e, filterTag) => {
        const updatedTags = tagsData?.filter((tag) => tag?.id !== filterTag?.id);
        setTagsData(updatedTags);
        setIsChecked((prev) => prev?.filter((id) => id !== filterTag?.id));

        //  Update the items, but DON'T touch _original
        if (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR) {
            const updatedItems = formik?.values?.exhibitors?.items?.filter(
                item => item?.id !== filterTag?.id
            ) || [];

            formik.setFieldValue('exhibitors.items', updatedItems);

        } else {
            const updatedItems = formik?.values?.categories?.items?.filter(
                item => item?.id !== filterTag?.id
            ) || [];

            // only update items, keep _original intact
            formik.setFieldValue('categories.items', updatedItems);
        }
    };


    const toggleSelectAll = () => {
        const isAllSelected = isChecked?.includes("all")

        if (isAllSelected) {
            setIsChecked([])
            setTagsData([])
        } else {
            const sel = filterTags?.map((tag) => tag?.id || tag?.category_id)
            const sel2 = filterTags?.map((tag) => ({
                id: tag?.id || tag?.category_id,
                name: tag?.name || tag?.category_name,
            }))
            setIsChecked([...sel, "all"])
            setTagsData(sel2)
        }
    }

    const onValueSelect = (e, val) => {
        if (val.id === "all") {
            toggleSelectAll()
            return
        }

        const isAlreadySelected = isChecked?.includes(val?.id)

        if (isAlreadySelected) {
            if (isChecked?.includes("all")) {
                const updatedChecked = isChecked?.filter((id) => id !== val?.id && id !== "all")
                setIsChecked(updatedChecked)
                setTagsData(tagsData?.filter((tag) => tag?.id !== val?.id))
            } else {
                const updatedChecked = isChecked?.filter((id) => id !== val?.id)
                setIsChecked([...updatedChecked])
                setTagsData([...tagsData?.filter((tag) => tag?.id !== val?.id)])
            }
        } else {
            if (isChecked?.length > 0 && isChecked?.length === filterTags?.length - 1) {
                setIsChecked([...isChecked, "all", val?.id])
                setTagsData([...tagsData, val])
            } else {
                setIsChecked([...isChecked, val?.id])
                setTagsData([...tagsData, val])
            }
        }
    }

    const enhancedFilterTags = [
        ...(filterTags?.length > 0 && filterTags?.find((tag) => tag?.id !== "all") ? [{ id: "all", name: "All" }] : []),
        ...filterTags?.map((tag) => ({
            id: tag?.id || tag?.category_id,
            name: tag?.name || tag?.category_name,
        }))
    ]

    const getUploadedFiles = async (files) => {
        setFileUploadLoading(true)
        try {
            if (files && files?.length > 0) {
                const needsUpload = files?.some(file => typeof file !== JS_TYPES?.OBJECT || !file?.url);

                const uploadedFiles = await Promise.all(
                    files?.map(async (file) => {
                        if (file && typeof file === JS_TYPES?.OBJECT && file?.url) {
                            return file;
                        } else {
                            const uploadedUrl = await uploadFile(file, 20);
                            return { file_name: file?.name, url: uploadedUrl, file_type: file?.type, file_size: file?.size };
                        }
                    })
                );

                setFileUploadLoading(false);
                formik.setFieldValue("files", [...uploadedFiles]);

                if (needsUpload) {
                    customToast.success(SUCCESS_MESSAGES?.FILE_MESSAGE);
                }
            }
        } catch (error) {
            customToast.error(ErrMessages?.DEFAULT_ERROR_MESSAGE, error);
        }
    };

    const handleAssetTypeChange = (selectedOption) => {

        const newAssetType = selectedOption?.value
        const currentAssetType = formik?.values?.task_type

        const shouldShowModal =
            newAssetType !== currentAssetType &&
            formik?.values?.files &&
            formik?.values?.files?.length > 0 &&
            (
                (isEdit && requiresFileUpload(currentAssetType)) ||
                (!requiresFileUpload(newAssetType) && requiresFileUpload(currentAssetType))
            )

        if (shouldShowModal) {
            setPendingAssetType(selectedOption)
            setAssetTypeChangeModal(true)
        } else {
            applyAssetTypeChange(selectedOption)
        }
    }


    const applyAssetTypeChange = (selectedOption) => {
        const assetType = selectedOption?.value || '';
        const mappedType = ASSET_TYPE_MAPPING[assetType] || 2;

        formik.setFieldValue('task_type', mappedType);

        if (!requiresFileUpload(assetType)) {
            formik.setFieldValue('files', []);
        }
    };

    const handleDropdownChange = (fieldName, selectedOption) => {
        if (fieldName === 'task_type') {
            handleAssetTypeChange(selectedOption)
        } else {
            formik.setFieldValue(fieldName, selectedOption?.value || '')
        }
    }

    const handleAssetTypeChangeConfirmation = () => {
        if (pendingAssetType) {
            applyAssetTypeChange(pendingAssetType)
            formik.setFieldValue('files', [])
        }

        setAssetTypeChangeModal(false)
        setPendingAssetType(null)
    }

    const handleAssetTypeChangeCancel = () => {
        setAssetTypeChangeModal(false)
        setPendingAssetType(null)
    }

    const handleAutoAssignChange = (e) => {
        const isChecked = e?.target?.checked;

        if (isChecked) {
            const autoAssignType = toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR ? 1 : 2;
            formik.setFieldValue("auto_assign_type", autoAssignType);
        } else {
            formik.setFieldValue("auto_assign_type", null);  // Set to null when unchecked
        }
    };

    
    const getOptionLabel = (option) => option?.label || option?.name || ''

    const requiresFileUpload = (assetType) => {
        const type =
            typeof assetType === "number"
                ? ASSET_TYPE_REVERSE_MAPPING[assetType]
                : assetType;

        return !["Link (URL)", "Text"].includes(type);
    };

    useEffect(() => {
        if (isEdit && formik?.values?.category_ids?.length > 0 && categoryData?.length > 0 && !isInitialized) {
            const currentCategoryItems = formik?.values?.categories?.items || [];

            if (currentCategoryItems?.length === 0) {

                const categoryItems = formik?.values?.category_ids
                    .map(catId => {
                        const category = categoryData?.find(
                            cat => cat?.category_id?.toString() === catId?.toString()
                        );

                        if (category) {
                            return {
                                id: category?.category_id,
                                category_name: category?.category_name
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);

                formik.setFieldValue('categories.items', categoryItems);
                formik.setFieldValue('categories._original', JSON.parse(JSON.stringify(categoryItems)));
            }
        }
    }, [isEdit, formik?.values?.category_ids?.length, categoryData?.length]);

    //  Set toggle mode ONCE based on data
    useEffect(() => {
        if (!categoryData?.length || !exhibitorData?.length || isInitialized) return;

        const category_ids = formik?.values?.category_ids || [];
        const category_items = formik?.values?.categories?.items || [];
        const exhibitor_items = formik?.values?.exhibitors?.items || [];

        if (category_ids?.length > 0 || category_items?.length > 0) {
            setToggleState({ toggleMode: TOGGLEMODE?.CATEGORY });
            setFilterTags(categoryData);
        } else if (exhibitor_items.length > 0) {
            setToggleState({ toggleMode: TOGGLEMODE?.EXHIBITOR });
            setFilterTags(exhibitorData);
        } else {
            setToggleState({ toggleMode: TOGGLEMODE?.EXHIBITOR });
            setFilterTags(exhibitorData);
        }

        setIsInitialized(true); //  Mark as initialized
    }, [categoryData?.length, exhibitorData?.length]);

    //  Initialize tagsData ONCE in edit mode
    useEffect(() => {
        if (!isEdit || !isInitialized) return;
        if (tagsData.length > 0) return; //  Already initialized

        const editExhibitorData = formik?.values?.exhibitors?.items || [];
        const editCategoryData = formik?.values?.categories?.items || [];

        if (toggleState?.toggleMode === TOGGLEMODE.EXHIBITOR && editExhibitorData?.length > 0) {
            const ids = editExhibitorData?.map(item => item?.id);
            const tags = editExhibitorData?.map(item => ({
                id: item?.id,
                name: item?.entity_name
            }));

            setIsChecked(exhibitorData.length === editExhibitorData.length ? [...ids, 'all'] : ids);
            setTagsData(tags);
            setFilterTags(exhibitorData);

        } else if (toggleState?.toggleMode === TOGGLEMODE?.CATEGORY && editCategoryData?.length > 0) {
            const ids = editCategoryData?.map(item => item?.id);
            const tags = editCategoryData?.map(item => ({
                id: item?.id,
                name: item?.category_name
            }));

            setIsChecked(categoryData?.length === editCategoryData?.length ? [...ids, 'all'] : ids);
            setTagsData(tags);
            setFilterTags(categoryData);
        }
    }, [isEdit, isInitialized, toggleState?.toggleMode, exhibitorData?.length, categoryData?.length]);

    //   Update formik when tagsData changes (CREATE mode or user selection)
    useEffect(() => {
        if (!isInitialized) return; 
        if (isEdit && tagsData?.length === 0) return; //  Don't clear on edit initialization

        const selectedIds = tagsData
            ?.filter((item) => item?.id !== 'all')
            ?.map((item) => item?.id?.toString());


        if (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR) {
            const exhibitorItems = selectedIds?.map(id => {
                const existing = formik?.values?.exhibitors?.items?.find(item => item.id.toString() === id);
                if (existing) return existing;

                const exhibitor = exhibitorData?.find(e => (e?.category_id || e?.id).toString() === id);
                return {
                    id: parseInt(id),
                    entity_name: exhibitor?.category_name || exhibitor?.entity_name || ''
                };
            });

            //  Only update if changed
            const currentIds = (formik?.values?.exhibitors?.items || [])?.map(i => i?.id.toString())?.sort()?.join(',');
            const newIds = selectedIds?.sort()?.join(',');

            if (currentIds !== newIds) {
                formik.setFieldValue("exhibitors.items", exhibitorItems);
            }
            setIsExhibitorToggle(true);

        } else if (toggleState?.toggleMode === TOGGLEMODE?.CATEGORY) {
            const categoryItems = selectedIds?.map(id => {
                const existing = formik?.values?.categories?.items?.find(item => item?.id?.toString() === id);
                if (existing) return existing;

                const category = categoryData?.find(c => c?.category_id?.toString() === id);
                return {
                    id: parseInt(id),
                    category_name: category?.category_name || ''
                };
            });

            //  Only update if changed
            const currentIds = (formik?.values?.categories?.items || [])?.map(i => i?.id?.toString())?.sort()?.join(',');
            const newIds = selectedIds?.sort()?.join(',');

            if (currentIds !== newIds) {
                formik.setFieldValue("categories.items", categoryItems);
            }
            setIsExhibitorToggle(false);
        }
    }, [tagsData, toggleState?.toggleMode, isInitialized]);
    return (
        <div>
            <KonfhubContainer>
                <>
                    {formik?.values && Object?.keys(formik?.values)?.length !== 0 ? (
                        <div className="">
                            <form onSubmit={formik?.handleSubmit}>
                                <div className="row">
                                    <div className="col-12 col-md-12 pt-1">
                                        <div>
                                            <label htmlFor="title" className="label  mt-2">
                                                Asset Title <span className="text-danger"> *</span>
                                            </label>
                                        </div>
                                        <div>
                                            <input
                                                id="title"
                                                name="title"
                                                placeholder="Enter asset title"
                                                type="text"
                                                onChange={formik?.handleChange}
                                                onBlur={formik?.handleBlur}
                                                value={formik?.values?.title}
                                                className={
                                                    formik?.errors?.title && formik?.touched.title
                                                        ? "input border-danger box-shawdow-none"
                                                        : "input task-input-label"
                                                }
                                            />
                                            {formik?.errors?.title && formik?.touched?.title && (
                                                <p className="text-danger mt-2">{formik?.errors?.title}</p>
                                            )}
                                        </div>
                                    </div>


                                    <div className="col-12 col-md-12 pt-1 mt-2">
                                        <div>
                                            <label htmlFor="description" className="label mt-2">
                                                Asset Description
                                            </label>
                                        </div>
                                        <div>
                                            <RichTextEditor
                                                value={formik?.values?.description || ''}
                                                onChange={updateContent}
                                                placeholder="Enter your asset description here"
                                                preset="extended"
                                            />
                                            <div className="d-flex justify-content-between">
                                                <p className="text-danger mt-2 pt-1 mb-0">
                                                    {formik?.errors?.description &&
                                                        formik?.touched?.description && (
                                                            <p>{formik?.errors?.description}</p>
                                                        )}
                                                </p>
                                                <p className="maxCharForInput">
                                                    Maximum Characters: {CHAR_LIMITS?.taskDescription?.descMax || 500}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 pt-1 mt-2">
                                        <div>
                                            <label htmlFor="task_type" className="label mt-2">
                                                Asset Type <span className="text-danger"> *</span>
                                            </label>
                                        </div>
                                        <div>
                                            <DropdownWithIcon
                                                value={assetTypeOptions?.find(
                                                    (option) => option?.value === formik?.values?.task_type,
                                                )}
                                                options={assetTypeOptions}
                                                onChange={(option) =>
                                                    handleDropdownChange("task_type", option)
                                                }
                                                onBlur={() => formik.setFieldTouched("task_type", true)}
                                                getOptionLabel={getOptionLabel}
                                                disabled={isEdit}
                                                className={`task-dropdown ${isEdit ? "task-dropdown-disabled" : ""}`}
                                            />
                                            {formik?.errors?.task_type && formik?.touched?.task_type && (
                                                <p className="text-danger mt-2">{formik?.errors?.task_type}</p>
                                            )}
                                        </div>
                                    </div>
                                    {formik?.values?.task_type === ASSET_TYPE_MAPPING['Link (URL)'] && (
                                        <div className="col-12 col-md-12 pt-1 mt-2">
                                            <div>
                                                <label htmlFor="asset_link" className="label mt-2">
                                                    Link <span className="text-danger"> *</span>
                                                </label>
                                            </div>
                                            <div>
                                                <input
                                                    id="asset_link"
                                                    name="asset_link"
                                                    placeholder="https://example.com"
                                                    type="url"
                                                    onChange={formik?.handleChange}
                                                    onBlur={formik?.handleBlur}
                                                    value={formik?.values?.asset_link || ''}
                                                    className={
                                                        formik?.errors?.asset_link && formik?.touched?.asset_link
                                                            ? "input border-danger box-shawdow-none"
                                                            : "input task-input-label"
                                                    }
                                                />
                                                {formik?.errors?.asset_link && formik?.touched?.asset_link && (
                                                    <p className="text-danger mt-2">{formik?.errors?.asset_link}</p>
                                                )}
                                            </div>
                                        </div>
                                    )}


                                    {requiresFileUpload(formik?.values?.task_type) && (
                                        <UploadFiles
                                            isEdit={isEdit}
                                            formik={formik}
                                            getUploadedFiles={getUploadedFiles}
                                            loading={fileUploadLoading}
                                            isAssetScreen={true}
                                        />
                                    )}

                                    <div className="col-12 col-md-12 pt-1 mt-2">
                                        <div className="d-flex align-items-center">
                                            <span className="label manual-label-text asset-library-form-checkbox-title">
                                                Share with Exhibitors
                                            </span>
                                            <div className="mx-3">
                                                <TwoLabelSwitch
                                                    value={toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR}
                                                    onChangeSwitch={(value) => {
                                                        const newMode = value
                                                            ? TOGGLEMODE?.CATEGORY
                                                            : TOGGLEMODE?.EXHIBITOR
                                                        updateAssigneeToggle("toggleMode", newMode)
                                                    }}
                                                />
                                            </div>
                                            <span className="label asset-library-form-checkbox-title">Share with Categories</span>
                                        </div>
                                        <TagsComponent
                                            addMultipleTagsButton={false}
                                            placeholder={toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR
                                                ? "Search by typing an exhibitor name"
                                                : "Search by typing a category name"
                                            }
                                            noDataText={
                                                toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR
                                                    ? (tagsData?.length === 0 || filterTags?.length === 0
                                                        ? "No Exhibitors found"
                                                        : "")
                                                    : (categoryData?.length === 0
                                                        ? "No Categories found"
                                                        : "")
                                            }
                                            tagsData={tagsData}
                                            dragEnd={null}
                                            editIcon={false}
                                            deleteIcon={true}
                                            deleteClickHandler={deleteClickHandler}
                                            isDragDisabled={true}
                                            value={value}
                                            handleChange={handleChange}
                                            CheckboxDropdownData={enhancedFilterTags}
                                            onValueSelect={onValueSelect}
                                            openSelectTicketDropdown={openSelectTicketDropdown}
                                            setOpenSelectTicketDropdown={setOpenSelectTicketDropdown}
                                            isChecked={isChecked}
                                            setValue={setValue}
                                            setTagsData={setFilterTags}
                                            addNewValueinDropDown={false}
                                            openDropDown={openDropDown}
                                            isSelectInclude={true}
                                            showNoDataMessage={false}
                                        />
                                        <div>
                                            {toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR && formik.errors.exhibitor_ids && formik?.touched?.exhibitor_ids && (
                                                <p className="text-danger mt-2">{formik?.errors?.exhibitor_ids}</p>
                                            )}
                                            {toggleState?.toggleMode === TOGGLEMODE?.CATEGORY && formik?.errors?.category_ids && formik?.touched?.category_ids && (
                                                <p className="text-danger mt-2">{formik?.errors?.category_ids}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between mt-4">
                                    <div className="d-flex align-items-center">
                                        <div className="d-flex justify-content-center aligns-items-center">
                                            <Checkbox
                                                labelClassName="checkboxCard-label ml-1"
                                                checked={formik?.values?.auto_assign_type === (toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR ? 1 : 2)}
                                                onChange={handleAutoAssignChange}
                                            />

                                            <span className="label asset-library-form-input-title pr-2">
                                                {`Auto Share with Future ${toggleState?.toggleMode === TOGGLEMODE?.EXHIBITOR
                                                    ? "Exhibitors"
                                                    : "Exhibitors of the Selected Categories"
                                                    }`}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-2 loadingCenter">
                                    <FormButtons
                                        isLoading={loading || formik.isSubmitting}
                                        formik={formik}
                                        onSave={() => {
                                            scrollToError(formik)
                                            formik.submitForm()
                                        }}
                                        onCancel={() => {
                                            formik.handleReset()
                                            history.push(
                                                `/e/${eventId}/exhibitor-portal/asset-library`)
                                        }}
                                        saveBtnContent={isEdit ? "Save" : "Add"}
                                        saveBtnDisabled={loading || !formik.dirty || formik.isSubmitting || fileUploadLoading }
                                    />
                                </div>
                            </form>
                            <DeleteModal
                                width={"420px"}
                                openModal={assetTypeChangeModal}
                                setOpenModal={setAssetTypeChangeModal}
                                primaryBtnContent={"Yes"}
                                cancelBtnContent={"No"}
                                item=""
                                extraComponent={
                                    <p className="mt-4 uploaded-images change-asset-type-cont">
                                        <b>Note: </b>
                                        <span className="change-asset-noteText">
                                            Changing the asset type will delete all the files you've already uploaded.
                                        </span>
                                    </p>
                                }
                                text={`  <b>Change Asset Type </b>  <br /> Do you want to change the asset type?`}
                                onCancel={handleAssetTypeChangeCancel}
                                onOkay={handleAssetTypeChangeConfirmation}
                            />
                        </div>
                    ) : (
                        <LoadingSpinner />
                    )}
                    <style>{`
                        .task-upload-container {
                            width: 100%;
                        }
                        .asset-library-form-input-title{
                             color: ${dashboardColors[theme].primaryTextColor} !important;
                            margin-bottom: 5px;
                        }
                        .asset-library-form-checkbox-title{
                            color: ${dashboardColors[theme].primaryTextColor} !important;
                        }
                        .asset-library-form-input-subtitle{
                            color:#333333;
                            font-size:14px;
                            font-weight:400;
                        }
                        .checkboxCard-label{
                            margin-top:5px;
                        }

                        .change-asset-type-cont {
                            background-color: #f8f8f8;
                            padding: 10px;
                            color: #6c757d;
                            border-radius: 5px;
                            border: 1px solid #e2e2e2;
                            font-size: 15px;
                            line-height: 24px;
                        }
            
                        .task-dropdown-disabled {
                            opacity: 0.6;
                            pointer-events: none;
                        }
                        .change-asset-type-cont b{
                            color:${dashboardColors[theme].primaryTextColor} !important;
                        }
                        .change-asset-noteText{
                            font-size:14px;
                            font-weight:400;
                            color:${dashboardColors[theme].primaryTextColor} !important;
                        }
                    `}</style>
                </>
            </KonfhubContainer>
        </div>
    )
}

export default AddNEditAsset
